<template>
  <header class="dashboard-header">
    <nav class="navbar fixed-top">
      <button 
        id="d_toggler"
        class="nav-toggler open" 
        @click.prevent="openNav"
      >
        <span class="nav-toggler-icon" />
      </button>
      <div class="nav-left">
        <router-link 
          :to="{
            name: 'MyPractice'
          }" 
          tag="a" 
          class="user-info"
        >
          <strong>Hello, {{ currentUser.first_name }}<span v-if="currentUser.last_name"> {{ currentUser.last_name }}</span>!</strong>
          <span 
            v-if="isRole('super_admin')" 
            class="user-tag"
          >
            Super Admin</span>
          <span 
            v-else-if="isRole('practice_admin')" 
            class="user-tag"
          >
            Practice Admin</span>
          <span 
            v-else-if="isRole('physician')" 
            class="user-tag"
          >
            Skincare Pro</span>
          <span 
            v-else-if="isRole('esthetician')" 
            class="user-tag"
          >
            Esthetician</span>
          <span 
            v-else-if="isRole('group_admin')" 
            class="user-tag"
          >
            Group Admin</span>
          <span 
            v-else-if="isRole('group_practice_admin')" 
            class="user-tag"
          >
            Group Practice Admin</span>
          <span 
            v-else-if="isRole('authorized_principal')" 
            class="user-tag"
          >
            Authorized Principal</span>
          <span 
            v-else 
            class="user-tag"
          >
            Staff</span>
        </router-link>
      </div>
      <div class="nav-right">
        <div v-if="currentPractice && currentPractice.account_manager" class="dropdown">
          <a
            id="dropdownMenuLink"
            class="dropdown-toggle"
            href="#"
            role="button"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
          >
            Account Manager: {{ currentPractice.account_manager.name }}
          </a>

          <div class="dropdown-menu" aria-labelledby="dropdownMenuLink">
            <a
              v-if="currentPractice.account_manager.booking_link"
              class="dropdown-item hover-btn"
              :href="currentPractice.account_manager.booking_link.startsWith('http') 
                        ? currentPractice.account_manager.booking_link 
                        : 'https://' + currentPractice.account_manager.booking_link"
              target="_blank"
              rel="noopener noreferrer"
            >
              Schedule Meeting
            </a>
            <a
              v-if="currentPractice.account_manager.phone"
              class="dropdown-item hover-btn"
              :href="`tel:${currentPractice.account_manager.phone}`"
            >
              {{ formatPhone(currentPractice.account_manager.phone) }}
            </a>
            <a
              v-if="currentPractice.account_manager.email"
              class="dropdown-item hover-btn"
              :href="`mailto:${currentPractice.account_manager.email}`"
            >
              {{ currentPractice.account_manager.email }}
            </a>
          </div>
        </div>

        <div class="dropdown">
          <a
            id="dropdownMenuLink"
            class="dropdown-toggle"
            href="#"
            role="button"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
          >
            My Account
          </a>
          <div class="dropdown-menu" aria-labelledby="dropdownMenuLink">
            <router-link class="dropdown-item" :to="{ name: 'MyAccount' }">
              Account Settings
            </router-link>

            <router-link
              v-if="currentUser.show_statements"
              class="dropdown-item"
              :to="{ name: 'RoyaltyStatement' }"
            >
              Statements
            </router-link>

            <a class="dropdown-item hover-btn" @click="logout">Log Out</a>
          </div>
        </div>

        <a
          class="help-link"
          target="_blank"
          href="https://regimenmd.myshopify.com/pages/contact-us"
        >
          Need Help?
        </a>
      </div>
    </nav>
  </header>
  <!-- /. dashboard-header -->
</template>

<script>
import { mapGetters } from 'vuex';
import { destroyToken } from '../../../services/jwt.service';
import { LOGOUT } from '../../../store/login/actions.types';

export default {
  name: 'Header',
  props: {
    practices: {
      type: Array,
      default: () => []
    },
    practiceId: {
      type: [String, Number],
      default: null
    }
  },
  computed: {
    ...mapGetters([
      'currentUser',
      'practice'
    ]),

    currentPractice() {
      // Super admin sees selected practice
      if (this.isRole('super_admin') && this.practiceId) {
        return this.practices.find(p => String(p.id) === String(this.practiceId)) || {};
      }
      // Others see their own practice
      return this.practice || {};
    }
  },
  methods: {
    // @vuese
    // Used to logout user, destroy JWT token and redirect to Login page
    logout() {
      destroyToken();
      this.$store.dispatch(LOGOUT).then(
        () => {
          document.afterLogOut = true;
          this.$router.push({name: 'Login'});
        }
      );
    },
    // @vuese
    // Used to open nav in mobile
    openNav() {
      document.querySelector('.dashboard-nav').classList.add('open-nav');
    },

    formatPhone(phone) {
      if (!phone) return '';
      const digits = phone.replace(/\D/g, '');
      if (digits.length === 10) {
        return `(${digits.slice(0,3)}) ${digits.slice(3,6)}-${digits.slice(6,10)}`;
      } else if (digits.length === 9) {
        return `(${digits.slice(0,3)}) ${digits.slice(3,6)}-${digits.slice(6,9)}`;
      } else {
        return phone; // fallback
      }
    }
  }
};
</script>
